import React, { useEffect, useState } from 'react';
import {
    Card,
    Button,
    Image,
    Spinner,
    Modal,
    Alert,
    Badge
} from 'react-bootstrap';
import {
    Link
} from "react-router-dom";
import { faAward, faVideo, faUsers, faChalkboardTeacher, faLightbulb, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AcademyNavbar from './AcademyNavbar';
import AcademyFooter from './AcademyFooter';
import firebase from 'firebase';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faAward, faVideo, faUsers, faChalkboardTeacher, faLightbulb, faArrowRight);

const ThankYou = (props) => {
    const [currentProgramBrouchure, setCurrentProgramBrochure] = useState('');
    const [programList, setProgramList] = useState([]);

    // Reading from local storage to get the url of brochure
    useEffect(() => {
        if((window.localStorage.getItem('requestedbrochureURL')) === 'undefined'){
            props.history.push('/');
        }else{
            setCurrentProgramBrochure(JSON.parse(window.localStorage.getItem('requestedbrochureURL')));
        }
        
    }, [])

    // Getting list of all the programs
    useEffect(() => {
        let programListRef = firebase.firestore().collection('/Variants/pt-BR/programList');
        let allPrograms = programListRef.orderBy("position", "asc").get()
            .then(snapshot => {
                let tempProgramList = [];

                snapshot.forEach(doc => {
                    tempProgramList.push({ programSlug: doc.id, ...doc.data() });
                });
                setProgramList(tempProgramList);
            })
            .catch(err => {
                console.log('Error getting documents', err);
            });
    }, [])

    return (
        <>
            <AcademyNavbar />
            <div className="container">
                <h1 className="h1 font-weight-normal text-white mt-3 mb-2">Thank You!</h1>
                <h2 className="h3 font-weight-light text-white">Você pode baixar o panfleto <a href={currentProgramBrouchure} target="_blank">clicando aqui</a>. Também enviamos o link para download do panfleto no seu e-mail.</h2>
                <h2 className="h3 mt-5 font-weight-light text-white">Check out our other programs</h2>
                <br></br>
                <div className="row">
                    {programList.map((item, key) => {
                        if (+item.position >= 0) {
                            return (
                                <div className="col-md-4" key={key}>
                                    <Link className="link" to={`/program/${item.programSlug}`}>
                                        <Card className="mb-3 border-0" bg="transparent" text="white">
                                            <Card.Img variant="top" src={item.programThumbnail} />
                                            <Card.Body className="px-0">
                                                <span className="small mb-4 text-warning">STARTS OCTOBER 2020</span>
                                                <Card.Title>{item.programTitle}</Card.Title>
                                                <Card.Text className="small">{item.programSubTitle}</Card.Text>
                                                <div className="row">
                                                    <div className="col">
                                                        {item.associatedUniversities && <div>
                                                            <p className="small font-weight-bold text-secondary">Learn and interact through live online classes with world class faculty from</p>
                                                            <div className="row">
                                                                {item.associatedUniversities.map(university =>
                                                                    <p className="col-md-6 mb-1 small ">{university}</p>
                                                                )}
                                                            </div>
                                                        </div>}
                                                    </div>
                                                </div>
                                                <span className="text-muted">Learn More <FontAwesomeIcon icon={faArrowRight} size="sm" color="grey" /></span>
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </div>
                            )
                        }
                    }
                    )}
                </div>
            </div>
            <AcademyFooter />
        </>
    );
}


export default ThankYou;
